import { memo } from 'react';

import { Layout } from '@sravni/react-design-system/lib/Layout';

import type { IFilters } from '@src/@types/microcredits';
import { useHeadingTexts } from '@src/components/PageHeader/hooks';
import { Calculator } from 'features/Calculator';

import { DEFAULT_HEADING, DEFAULT_SUB_HEADING } from './CalculatorPageHeader.config';
import styles from './CalculatorPageHeader.module.scss';

type Props = {
  filters: Partial<IFilters>;
};

export const CalculatorPageHeader: React.FC<Props> = memo(({ filters }) => {
  const { headingText, subHeadingText } = useHeadingTexts({
    defaultHeading: DEFAULT_HEADING,
    defaultSubHeading: DEFAULT_SUB_HEADING,
  });

  return (
    <div className={styles.page_header}>
      <Layout className={styles.layout}>
        <h1 className={styles.title}>{headingText}</h1>
        <p className={styles.subheading}>{subHeadingText}</p>
        <Calculator filters={filters} />
      </Layout>
    </div>
  );
});

CalculatorPageHeader.displayName = 'CalculatorPageHeader';
